"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = exports.RoutesContext = void 0;

var _react = _interopRequireWildcard(require("react"));

/**
 * React context for accessing the tree of routes.
 * @package
 */
var RoutesContext = /*#__PURE__*/(0, _react.createContext)({
  routes: []
});
exports.RoutesContext = RoutesContext;
RoutesContext.displayName = "RoutesContext";
/**
 * Provider for the Routes context
 * @param {Routes} routes A list of routes within an app.
 * @param children React children.
 * @package
 */

var RoutesProvider = function RoutesProvider(_ref) {
  var routes = _ref.routes,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(RoutesContext.Provider, {
    value: routes
  }, children);
};

var _default = RoutesProvider;
exports["default"] = _default;